exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer.footer-container{flex-shrink:0;width:100%;min-height:30px;padding:6px 0;font-size:12px;justify-content:flex-end;flex-wrap:wrap;gap:4px}footer.footer-container .footer-attribution{display:inline-flex;align-items:center;gap:2px}footer.footer-container .footer-divider-vertical{margin:0 2px;background:#000;width:1px;height:14px}footer.footer-container .app-version-container{overflow-wrap:anywhere}", ""]);

// exports
